import { BasePlayer } from "@/components/organisms/Players/MrDbListCardView/PlayersCardView";
import {
  BasePlayerTierAndMetaRating,
  getTier,
  playerRolesSelector,
} from "@/redux/players/playersSlice";
import { useMemo } from "react";
import { useSelector } from "react-redux";

// A hook, not a selector: only playerRoles comes from the store (stable ref),
// and a selector returning the derived object would re-render every card on
// every dispatched action.
export const useBasePlayerTierAndMetaRating = (
  basePlayer: BasePlayer | undefined,
  playerRoleId: number,
  newDesign = false,
): BasePlayerTierAndMetaRating | null => {
  const playerRoles = useSelector(playerRolesSelector);
  const metaRating = basePlayer?.metaRating;

  return useMemo(
    () =>
      metaRating === undefined
        ? null
        : {
            metaRating,
            tier: getTier(playerRoles, metaRating, playerRoleId, newDesign),
          },
    [playerRoles, metaRating, playerRoleId, newDesign],
  );
};
